import { render } from "./Alert5.vue?vue&type=template&id=baa66cce"
import script from "./Alert5.vue?vue&type=script&lang=js"
export * from "./Alert5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__